import { Logo } from "@/components/Logo";
import { useApp } from "@/context/AppContext";
import { T } from "@/i18n/translations";

export const Footer = () => {
  const { t, lang } = useApp();
  return (
    <footer className="bg-petrol-dark py-14 text-sand">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-3 lg:px-8">
        <div>
          <Logo light />
          <p className="mt-4 max-w-xs text-sm text-white/60">{T.footer.tagline[lang]}</p>
        </div>
        <div className="text-sm text-white/70">
          <p className="overline mb-3 text-gold">{t("nav.zones")}</p>
          <p>Punta · Stella Maris · Katoro · Umago Centro · Savudrija · Sirena · Kanegra</p>
        </div>
        <div className="text-sm text-white/60">
          <p className="overline mb-3 text-gold">Booking.com · bestprice·umago</p>
          <p>{T.footer.disclaimer[lang]}</p>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-7xl border-t border-white/10 px-5 pt-6 lg:px-8">
        <p data-testid="footer-rates-source" className="text-xs leading-relaxed text-white/45">
          {T.footer.rates_source[lang]}
        </p>
        <p className="mt-3 text-xs text-white/40">
          © {new Date().getFullYear()} Umago Best Price. {T.footer.rights[lang]}
        </p>
      </div>
    </footer>
  );
};
